<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="DataOverview")
    h1.title Gäste
    .sub-headline Hier sehen Sie alle Gäste.
    
    .button-wrapper.margin-top      
      b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'DataCustomerNew'})") Neuen Gast anlegen

    .card.margin-top
      .main
        b-field(label="Suche" label-position="on-border")
          b-input(v-model="searchString")
      .main    
        b-table(:data="searchResults"
                default-sort-direction="asc"
                hoverable)
          b-table-column(field='firstName' label='Vorname' sortable, v-slot="props")
            | {{props.row.firstName}}
          b-table-column(field='lastName' label='Nachname' sortable, v-slot="props")
            | {{props.row.lastName}}
          b-table-column(field='address.street' label='Straße' sortable, v-slot="props")
            | {{props.row.address.street}}
          b-table-column(field='address.zip' label='PLZ' sortable, v-slot="props")
            | {{props.row.address.zip}}
          b-table-column(field='address.city' label='Stadt' sortable, v-slot="props")
            | {{props.row.address.city}}
          b-table-column(field='address.email' label='E-Mail' sortable, v-slot="props")
            | {{props.row.address.email}}
          b-table-column(label='Aktionen', v-slot="props")
            .button-wrapper
              b-button(type="is-primary" @click="$router.push({ name: 'DataCustomerEdit', params: { id: props.row.id } })") Bearbeiten
              b-button(type="is-danger" @click="deleteCustomer(props.row)") Löschen
</template>

<script>
export default {
  data() {
    return {
      searchResults: [],
      searchString: ""
    };
  },
  computed: {
    // customers() {
    //   return this.$store.state.customers.all;
    // },
  },
  watch: {
    searchString() {
      this.selected = null
      this.updateSearch()
    }
  },
  methods: {
    async updateSearch() {
      this.searchResults = await this.$store.dispatch("customers/search", {searchString: this.searchString})
    },
    deleteCustomer(row) {
      this.$buefy.dialog.confirm({
        title: "Gast löschen",
        message: `Sind Sie sicher, dass Sie den Gast <b>${row.firstName} ${row.lastName}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Gast löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("customers/delete", { id: row.id });
            this.$buefy.toast.open("Gast gelöscht!");
            this.searchResults = await this.$store.dispatch("customers/search", {searchString: this.searchString});
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Gast konnte nicht gelöscht werden."
            );
          }
        }
      });
    }
  },
  // mounted() {
  //   this.$store.dispatch("customers/findAll");
  // }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>